export default __webpack_public_path__ + "static/unit-test-86fb4b5553424756c71edfcd431dc86d.webp";